var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73501 7.77501L17.095 0.409007C17.2237 0.279449 17.3768 0.17663 17.5454 0.106467C17.714 0.0363042 17.8949 0.000183105 18.0775 0.000183105C18.2601 0.000183105 18.441 0.0363042 18.6096 0.106467C18.7782 0.17663 18.9313 0.279449 19.06 0.409007C19.3195 0.671145 19.4651 1.02512 19.4651 1.39401C19.4651 1.76289 19.3195 2.11687 19.06 2.37901L10.72 10.724C10.4671 10.9764 10.1265 11.1216 9.76923 11.1292C9.41196 11.1368 9.06551 11.0064 8.802 10.765L0.402005 2.38501C0.140767 2.12443 -0.00625916 1.77075 -0.006728 1.40178C-0.00719684 1.0328 0.13893 0.678745 0.399505 0.417507C0.66008 0.156269 1.01376 0.0092436 1.38274 0.00877476C1.75171 0.00830591 2.10577 0.154432 2.36701 0.415008L9.73501 7.77501Z",
    fill: "#E8339E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.464,
    height: 11.129,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPink);
export default __webpack_public_path__ + "static/media/arrow_down_pink.b2293109138474aa71c2a496a30b26a8.svg";
export { ForwardRef as ReactComponent };